










































































































































































































































































































import {Component, Inject, Prop, Watch, Vue} from "vue-property-decorator";
import Api from "./Api";
import {
    DateTime, FamocoDevice,
    InvoicingExceptedTerminal,
    SimRow,
    TerminalConfigNext,
    TerminalGuiInfo,
    TerminalLocation
} from "../../modules/models";
import TerminalDescriptionEdit from "../terminal-description-edit/TerminalDescriptionEdit.vue";
import TerminalChangelocation from "../terminal-changelocation/TerminalChangelocation.vue";
import SuperTerminal from "../super/SuperTerminal.vue";
import SimStatusAlert from "./SimStatusAlert.vue";
import {FamocoInTheField, SimStatus, TheftAlarmMaxAndroidSdkVersion, UnimportantColor, WarningColor} from "../../modules/constants";
import LicenseTypePara from "./LicenseTypePara.vue";
import LicenseTypePopup from "@/components/systemsettings/LicenseTypePopup.vue"
import rd from "../../modules/vRoutedefs";
import UserRequired from "../UserRequired";
import InfoDialog from "../InfoDialog.vue";
import MonthChoice from "@/modules/MonthChoice";
import ContactLink from "@/components/shared/ContactLink.vue";
import {ignoreRedundantNavErr} from "@/router";
import TerminalAgeDialog from "@/components/terminals/TerminalAgeDialog.vue";
import SuperSheet from "@/components/shared/SuperSheet.vue";
import * as VueGoogleMaps from "vue2-google-maps";
import {GoogleMapsApiKey} from "../../modules/constants";
import {PluginFunction} from "vue";

Vue.use(VueGoogleMaps as PluginFunction<any>, {
  load: {
    key: GoogleMapsApiKey
  }
});

@Component({
    components: {
        "at-description-edit": TerminalDescriptionEdit,
        "at-changelocation": TerminalChangelocation,
        "at-super-terminal": SuperTerminal,
        "at-super": SuperSheet,
        "at-sim-status": SimStatusAlert,
        "at-license-type-para": LicenseTypePara,
        "at-info-dialog": InfoDialog,
        "at-contact-link": ContactLink,
        "at-age-dialog": TerminalAgeDialog,
        "at-license-pop": LicenseTypePopup,
    }
})
export default class TerminalPage extends UserRequired {
    @Inject()
    api!: Api;

    @Prop()
    guid!: string;

    readonly unimportantColor = UnimportantColor;
    readonly warningColor = WarningColor;
    readonly activationDocTo = rd.docs.terminal.reactivation.path;
    readonly terminalDocTo  = rd.docs.terminal.path;
    readonly networkConfigDocTo  = rd.docs.terminal.networksetup.path;
    readonly theftAlarmMaxAndroidSdkVersion = TheftAlarmMaxAndroidSdkVersion;

  info: TerminalGuiInfo | null = null;
    get configNext() {
      if(this.info != null) {
        return this.info.nextConfig;
      }
      return null;
    }
    invoicingExcepted: InvoicingExceptedTerminal[] = [];
    sim: SimRow | null = null;
    simLoading = false;

    minGoodVersion = 90;

    famoco: FamocoDevice | null = null;
    famocoInfoDialog = false;
    famocoOldFWDialog = false

    async cancelNextConfig() {
      if(this.configNext != null) {
        await this.api.deletePendingconfig(this.configNext.guid);
        this.emitSnack("Ventende konfigurasjon fjernet", "success");
        await this.loadInfo();
      }
    }

    get simNotActive() {
      return this.sim && this.sim.subscriptionStatusReported != SimStatus.active && this.sim.subscriptionStatusReported != SimStatus.pending;
    }

    get allowEdit() {
      return this.terminal && this.terminal.deactivated == null && (this.user.isCompanyAdmin(this.terminal.companyOrgNum) || this.user.isCompanyTerminalSetup(this.terminal.companyOrgNum)) ;
    }
    get allowConfigPush() {
      return this.terminal && this.user.isCompanyAdmin(this.terminal.companyOrgNum); // terminal setup users are not allowed to push configs to devices.
    }

    get terminal() {
      return this.info != null ? this.info.terminal : null;
    }

    get pendingDescriptionPush() {
      return this.terminal && this.configNext != null && this.configNext.pending && this.configNext.description != this.terminal.description;
    }
    get pendingLocationPush() {
      return this.configNext != null && this.configNext.pending && this.configNext.location != null && this.info != null &&
          (this.info.location == null || this.configNext.location.toJson() != this.info.location.toJson());
    }

    terminalDisconnectAlarmTo() {
      return {name: rd.terminals.terminal.disconnectAlarm.name, params: {guid: this.guid}};
    }

    theftAlarmStateTextMap = [
      "Alarm deaktivert",
      "Venter på aktivering",
      "Alarm ok, strøm tilkoblet",
      "Alarm ok, godkjent frakoblet",
      "Uautorisert frakobling",
      "Manglende signal",
    ];

    get theftAlarmText() {
      if(this.terminal) {
        return this.theftAlarmStateTextMap[this.terminal.theftAlarmState] || "Ukjent";
      }
      return "";
    }

    get readyForCleanup(): boolean {
      return this.terminal != null && this.terminal.cleanupTs == null &&
          this.terminal.grpcSubscribeTime == null &&
          (this.terminal.lastSyncTs == null || this.terminal.lastSyncTs.isBefore(DateTime.now().monthOffset(-1)))
    }
    // Marks the terminal ready for cleanup
    showTerminalCleanupSnack = false;
    showTerminalCleanupUndoSnack = false;
    async cleanupMark() {
      await this.api.terminalCleanupMark(this.guid);
      this.showTerminalCleanupSnack = true;
      await this.loadInfo();
    }
    get readyForResurrection(): boolean {
      return this.terminal != null && this.terminal.cleanupTs != null;
    }
    // Remove cleanup mark, resurrect terminal
    async resurrect() {
      const msg = await this.api.terminalCleanupUndo(this.guid);
      if(msg != null) {
        this.warningMsg = msg.msg;
      }
      this.showTerminalCleanupUndoSnack = true;
      await this.loadInfo();
    }

    async loadInfo() {
      this.info = await this.api.fetchTerminal(this.guid);
      // Incase the terminal displayed belongs to company other than currently active, set the active company accordingly.
      if(this.terminal && (this.baseApi.company == null || this.terminal.companyOrgNum != this.baseApi.company.orgNum)) {
        await ignoreRedundantNavErr(this.$router.replace({query: {orgnum: `${this.terminal.companyOrgNum}`}}));
      }
    }
    descriptionChanged() {
      this.showDescriptionEditedSnack = true;
      this.loadInfo();
    }

    showDescriptionEdit = false;
    showDescriptionEditedSnack = false;

    showConfirmDeactivation = false;
    showActivationInfo = false;
    showTerminalActivatedSnack = false;
    showTerminalDeactivatedSnack = false;
    activationWorking = false;
    async activate() {
      if(this.terminal) {
        try {
          this.activationWorking = true;
          await this.api.terminalActivate(this.terminal.guid);
          this.showTerminalActivatedSnack = true;
          await this.loadInfo();
          if(this.famoco) {
            await this.loadFamocoDeviceInfo(); // Since maintenance status might have changed when activating.
          }
        } finally {
          this.activationWorking = false;
        }
      }
    }
    activateOrInfoDialog() {
      if(this.famocoNotActive) {
        this.showActivationInfo = true;
      } else {
        this.activate();
        this.showActivationInfo = false;
      }
    }
    async deactivate() {
      if(this.terminal) {
        this.showConfirmDeactivation = false;
        try {
          this.activationWorking = true;
          this.askForLocShutdown = await this.api.terminalDeactivate(this.terminal.guid);
          // ^- Will display dialog asking if user wants to shutdown location too.
          this.showTerminalDeactivatedSnack = true;
          await this.loadInfo();
        } catch (err) {
          this.emitError(err);
        } finally {
          this.activationWorking = false;
        }
      }
    }
    get pendingSync() {
      return this.configNext != null;
    }

    locationTo() {
      if(this.info && this.info.location) {
        return {name: rd.locations.location.name, params: {locationId: this.info.location.id}};
      }
      return null;
    }

    showChangeLocation = false;
    showLocationChangedSnack = false;
    onLocationChanged() {
        this.showLocationChangedSnack = true;
        this.loadInfo();
    }

    showConfigPush = false;
    showConfigPushedSnack = false;
    configPushLoading = false;
    async pushConfig() {
        this.configPushLoading = true;
        await this.api.terminalConfigPush(this.guid);
        this.configPushLoading = false;
        this.showConfigPush = false;
        this.showConfigPushedSnack = true;
    }

    async loadInvoiceExceptions() {
        this.invoicingExcepted = await this.api.fetchInvoicingExceptedTerminals(this.guid);
    }
    invoicingExceptedHeaders = [
        {text: "Fra", value: "fromTs"},
        {text: "Til", value: "toTs"},
        {text: "Årsak", value: "reason"},
        {text: "", value: "", sortable: false}
    ];
    get invoiceExceptFromChoices(): MonthChoice[] {
        let ret: MonthChoice[] = [];
        for(let i = -8; i <= 2; i++) {
            ret.push(new MonthChoice(DateTime.now().monthOffset(i)));
        }
        return ret;
    }
    get invoiceExceptToChoices(): MonthChoice[] {
        let ret: MonthChoice[] = [];
        for(let i = -4; i <= 13; i++) {
            ret.push(new MonthChoice(DateTime.now().monthOffset(i)));
        }
        return ret;
    }
    get invoiceExceptReasons(): string[] {
        return [ "Defekt kortleser", "Programvarefeil", "Avtalt prøveperiode", "Godvilje", "Forhåndsfakturert", "Byttet firmatilknytning" ];
    }
    invoiceExceptFrom: DateTime | null = null;
    invoiceExceptTo: DateTime | null = null;
    invoiceExceptReason: string | null = null;
    async invoiceExceptAdd() {
        if(this.terminal && this.invoiceExceptFrom && this.invoiceExceptTo && this.invoiceExceptReason) {
            await this.api.addInvoicingExceptedTerminal(this.terminal.guid, this.invoiceExceptFrom, this.invoiceExceptTo, this.invoiceExceptReason);
            await this.loadInvoiceExceptions();
        }
    }
    async invoicingExceptedDelete(id: number) {
        await this.api.delInvoicingExceptedTerminal(id);
        await this.loadInvoiceExceptions();
    }

    @Watch("info", {immediate: true})
    async loadSimRow() {
        if(this.terminal && this.terminal.simSerial) {
            try {
                this.simLoading = true;
                this.sim = await this.api.fetchSimRow(this.terminal.simSerial)
            } catch(err) {
                this.emitError(err);
            } finally {
                this.simLoading = false;
            }
        }
    }

    warningMsg: string | null = null;
    get showWarningMsg() {
        return this.warningMsg != null;
    }
    set showWarningMsg(v: boolean) {
        if(!v) {
            this.warningMsg = null;
        }
    }

    versionTooOldDialog = false;

    askForLocShutdown: TerminalLocation | null = null;

    async locationShutdown() {
        if(this.askForLocShutdown != null) {
            try {
                this.activationWorking = true;
                const msg = await this.api.terminalLocationShutdown(this.askForLocShutdown.id);
                this.$emit("at-snack", msg.msg);
                this.askForLocShutdown = null;
            } finally {
                this.activationWorking = false;
            }
        }
    }

    async refreshFamocoDeviceInfo() {
      if(this.famoco) {
        await this.api.refreshFamocoDeviceInfo(this.famoco.id);
        // Reload fresh info
        this.famoco = await this.api.getFamocoDeviceInfo(this.guid);
      }
    }

    async loadFamocoDeviceInfo() {
        this.famoco = await this.api.getFamocoDeviceInfo(this.guid);
        try {
            if(this.famoco && this.famoco.shouldRefresh()) {
                // More than a minute since famoco info was last refreshed from api, refresh again.
                await this.refreshFamocoDeviceInfo();
            }
        } catch(e) { // Refresh failed. Will not report this exception as it is not critical.
            // Just log it to console
            console.warn(`Famoco device info refresh for id ${this.famoco && this.famoco.id} failed`, e);
        }
    }

    // Display imei from famoco info or reported from device itself
    get displayImei() {
        const deviceImei1 = this.terminal && this.terminal.phoneDeviceid || null
        const deviceImeiTrimmed = deviceImei1 != null && deviceImei1.length < 15;
        const famocoImei1 = this.famoco && (deviceImeiTrimmed ? this.famoco.trimmedImei1 : this.famoco.fullImei1);
        if(famocoImei1 != null && famocoImei1 != deviceImei1 && deviceImei1 != null) {
            return deviceImei1 + " -/- " + famocoImei1;
        }
        return deviceImei1 || famocoImei1;
    }

    get appVersion() {
        const famocoAppVersion = this.famoco && this.famoco.atAppVersionCode || 0;
        const appVersion = this.terminal && this.terminal.appVersion || 0;
        return Math.max(famocoAppVersion, appVersion);
    }

    get firmwareTooOld() {
        return this.famoco && this.famoco.model === "FX100,9" && this.famoco.firmwareVersion.lessThan(1, 11, 0);
    }

    ageInfoDialog = false;

    // Determine if old age warning should be displayed for the terminal.
    get ageOldWarning(): boolean {
      return this.terminal != null && this.terminal.technicalCheckDue
    }

    get webshopTo() {
      return {name: rd.shop.name};
    }

    async technicalCheckDone() {
      if(this.terminal != null) {
        await this.api.setTerminalTechnicalCheckDoneTs(this.terminal.guid);
        await this.loadInfo();
      }
      this.ageInfoDialog = false;
    }

    get famocoNotActive() {
      return this.famoco && this.famoco.maintenanceStatus != FamocoInTheField
    }

    famocoApiWorking = false;

    async famocoActivate() {
      if(this.famoco && this.terminal) {
        try {
          this.famocoApiWorking = true;
          await this.api.activateFamocoDevice(this.terminal.guid)
          await this.refreshFamocoDeviceInfo();
          this.emitSnack(`Aktivering utført`);
        } finally {
          this.famocoApiWorking = false;
        }
      }
    }

    get mapPosition() {
      return this.terminal?.geolocation ? {lat: this.terminal?.geolocation.latitude, lng: this.terminal?.geolocation.longitude} : null;
    }

    get mapPositionLocalDateTime() {
      return this.terminal?.geolocation?.dateTime.toLocalDateTime();
    }

    get mapPositionShouldDisplay() {
      const lastPosTime = this.terminal?.geolocation?.dateTime;
      const aMonthAgo = DateTime.now().monthOffset(-1);
      return lastPosTime != null && lastPosTime.isAfter(aMonthAgo);
    }

    showPositionPopup = false;

    // Hook
    created() {
        this.loadInfo();
        this.loadInvoiceExceptions();
        this.loadFamocoDeviceInfo()
    }
}
